import withPhotoUploadCache from './withPhotoUploadCache';

export default withPhotoUploadCache;
